import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import constants from '@constants';

class PaymentActionButtons extends Component {
	shouldComponentUpdate = ({ type : nextType, hasTransactionId : nextHasTransactionId }) => {
		const { type, hasTransactionId } = this.props;
		return !isEqual(type, nextType) || !isEqual(hasTransactionId, nextHasTransactionId);
	}

	render() {
		const {
			className, type, buttonClicked, user, hasTransactionId,
		} = this.props;
		return (
			<div className={`flex flex-center flex-direction-column ${className}`}>
				<Choose>
					<When condition={type === 'review'}>
						<Button
							bsStyle="primary"
							className="width-250"
							onClick={buttonClicked('individual')}
						>
							Approve Invoice
						</Button>
						<Button
							bsStyle="link"
							className="width-250"
							onClick={buttonClicked('dispute')}
						>
							Dispute Invoice
						</Button>
					</When>
					<When condition={type === 'paid' && hasTransactionId === true}>
						<Button
							bsStyle="primary"
							className="width-250"
							onClick={buttonClicked(type)}
						>
							Show Receipt
						</Button>
					</When>
					<When condition={type === 'payment' && user.IsStaffAdmin}>
						<Button
							bsStyle="primary"
							className="width-250"
							onClick={buttonClicked('payInvoice')}
						>
							Pay Invoice
						</Button>
						<Button
							bsStyle="link"
							className="width-250"
							onClick={buttonClicked('toReview')}
						>
							Change to Pending Review
						</Button>
					</When>
					<When condition={type === 'dispute'}>
						<Button
							bsStyle="link"
							className="width-250"
							onClick={buttonClicked('toReview')}
						>
							Change to Pending Review
						</Button>
					</When>
				</Choose>
			</div>
		);
	}
}

PaymentActionButtons.propTypes = {
	type : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	user             : PropTypes.object,
	className        : PropTypes.string,
	buttonClicked    : PropTypes.func,
	hasTransactionId : PropTypes.bool,
};

PaymentActionButtons.defaultProps = {
	type             : constants.INVOICE_STATUSES.PENDING_REVIEW,
	user             : {},
	className        : '',
	buttonClicked    : () => { },
	hasTransactionId : false,
};

export default PaymentActionButtons;
